import gql from 'graphql-tag'

export interface SpoonityValidUser {
  isValidated: boolean
  phone_number: string
  status: {
    'No Verification': boolean
    Email: boolean
    Sms: boolean
  }
}

export default gql`
  query verifiedUser($sessionKey: String) {
    spoonityValidUser(sessionKey: $sessionKey) {
      isValidated
      status
      phone_number
      methods
    }
  }
`
